import React, { useEffect, useState, useMemo, useCallback,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeListPersonsListed,
  SetEmployeeProfileDetailsID,
  SetISPendingDetails,
  getSideBarfilesActions,
  SetStatusBTN,
  getEmployeeListFilterPersonsListed,
  setThecountBasedRenders,
  setEditableActions,
  setTheoptions,
  setTheUserObjects, ///---User---Object
  sethtmlformatpdfdownoadActions, ////---Pdf---html----formats
  SetDashboards,
  SetTheDashboardClientList,
  setClientBranchSearchAction,
  getSingleEmployeeActions,
  setDropDownRenders,
  setTheUser_ID,
  setTheemployeeRoleId,
  setTheAllFormPdf,
  setTheTODATELISTINDASH,
  setTheFROMDATELIST,
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheEmployeeZoneName,
  setTheAttendanceregionObject,
  setTheAttendanceStateObject,
  setTheAttendanceZoneObject,
  setTheOnboardFromDateLIST,
  setOnboardTODtaeDASH,
  setEmployeeLstTodate,
  setTheEmployeeLISTfromdate,
  setTheApproveRequestStateObject , 

  setTheApproverequestRegionObject , 
  setTheApproveRequestZoneObject,
  setTheStatusFilter , 
  SettheBracnhId,
  SetTheDashboardonBoardOverViewClientList,
  settheJobinfoBranchEmployeeProfile,
  setTheRoleObjects,
  setTheBranchoptionsFieldAgent
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import "../../../StyleSheet/MainComponent/Management/EmployeeList.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import Security from "../../../Assets/AppComponent/icons/Role/Security.png";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { getBottomNavigationUtilityClass } from "@mui/material";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useInsertionEffect } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import ExcelFormatDwonload from "../Client/ExcelFormatDwonload";
import _ from "lodash";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//---icons
import excelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-15.svg";
import allformPdf from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-09.svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import useDebouncedEffect from 'use-debounced-effect';

const EmployeeList = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dateRangeRef = useRef(null);
  
  const [barnchName, setBranchName] = useState();
  const [Zone, setZone] = useState();
  const [EmpInquiry, setInquiry] = useState();
  const [sno, setsno] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [search, setsearch] = useState("");
  const [FState, SetStates] = useState(false);
  const [SubRoleList, setSubRoleList] = useState();
  const [nameList4, setOptions4] = useState([]);
  const [searchBranch, setSearch] = useState("");

  const [RenderStatus, setRenderStatus] = useState();
  ///---Filter----For---Sub---Roles---
  const [EMpROleSelected, setSubroleSelected] = useState({
    // value: "0",
    // label: "All",
    
    value:
      state.NumberCounts.namerednder == ""
        ? "0"

        :
         state.NumberCounts.namerednder == "Pending"
        ? "1"
        : state.NumberCounts.namerednder == "Approve" || state.NumberCounts.namerednder == "Approved"
        ? "1"
        : state.NumberCounts.namerednder == "Decline"
        ? "2"
        :  state.NumberCounts.namerednder == "kyc_completed" || state.NumberCounts.namerednder == "completed" ?
        
        "4"
        :"0"
        ,
    label:
      state.NumberCounts.namerednder == ""
        ? "ALL"
        : state.NumberCounts.namerednder == "completed"?  "Kyc Completed" :state.NumberCounts.namerednder ,
  });
   console.log(state.NumberCounts.namerednder ,"asdasdnamerednder" );
   


  const PayrollFilters = {
    // is_pending: true,
    // is_decline: "",
    // payroll_approved: false,
    dash_return_type: "payroll",
    inside_type: "all",
    kyc_completed:""


  };

  const [PayRollFilter, setPayrollFilter] = useState(PayrollFilters);

  const [roleIds, setroleIDs] = useState("1");
  const [SubRolePayROllOp, setSubRoleOption] = useState([
    // { value: "1", label: "Pending" }, //payroll_approved -false
    // { value: "2", label: "Decline" }, //is_decline -true ,payroll_approved - false
    // { value: "3", label: "Approve" }, // payroll_approved - true
    { value: "0", label: "All" },
    { value: "3", label: "Approved" }, // payroll_approved - true
    { value: "4", label: "Kyc Completed" },

    { value: "1", label: "Pending" }, //payroll_approved -false
    { value: "2", label: "Decline" }, //is_decline -true ,payroll_approved - false
  ]);

  const [Rmoptions, setRmoptions] = useState([
    { value: "0", label: "All" },
    { value: "1", label: "Approved" },

    { value: "2", label: "Pending" },
    { value: "3", label: "Decline" },
  ]);


  //  console.log(state.ClientBranchIDs.SUBROLE , "32846798237493", PayRollFilter , state.ClientBranchIDs.DashboardIDs);
  const [Rmfilter, setRmfilter] = useState({
    value:
      state.NumberCounts.namerednder == "completed"
        ? "1"
        : state.NumberCounts.namerednder == "Pending"
        ? "2"
        : state.NumberCounts.namerednder == "Approve" ||
          state.NumberCounts.namerednder == "completed"
        ? "1"
        : state.NumberCounts.namerednder == "Decline"
        ? "3"
        : "0",
    label:
      state.NumberCounts.namerednder == ""
        ? "ALL"
        : state.NumberCounts.namerednder,
  });
  const [RmFIlters, setRmFilters] = useState({
    dash_return_type: "rm",
    inside_type: "all",
  });
  const Rmfilter03 = (e) => {
    //  console.log(e , "982739817239872");
    // dispatch(SetDashboards(4))
    setdtPageindex(1);
    if (e != null) {
      setRmfilter(e);

      if (e.value == 0) {
        dispatch(setDropDownRenders(""));

        setRmFilters({
          ...RmFIlters,
          dash_return_type: "rm",
          inside_type: "all",
        });
      
      }

      if (e.value == 1) {
        setRmFilters({
          ...RmFIlters,
          dash_return_type: "rm",
          inside_type: "approved",
        });
        dispatch(setDropDownRenders("Approved"));

      
      }

      if (e.value == 2) {
        dispatch(setDropDownRenders("Pending"));
        setRmFilters({
          ...RmFIlters,
          dash_return_type: "rm",
          inside_type: "pending",
        });
      }

      if (e.value == 3) {
        dispatch(setDropDownRenders("Decline"));
        setRmFilters({
          ...RmFIlters,
          dash_return_type: "rm",
          inside_type: "decline",
        });
      }
    } else {
      setRmFilters({
        ...RmFIlters,
        dash_return_type: "rm",
        inside_type: "all",
      });
      dispatch(setDropDownRenders(""));

      setRmfilter({ value: "0", label: "All" });
    }
  };

  const [Client, setClients] = useState("");
  const [clientname, setClientName] = useState();

  ///---Branches------------------------------
  // const data = { state: "", region: "", zone: "" };

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.EmployeeVerificationsNeed.employeelistFROMDATE);
  var gt = convert(state.EmployeeVerificationsNeed.employeelistTODATE);
  //  console.log(state.EmployeeVerificationsNeed.FROMDATE , "EmployeeVerificationsNeed");
  // const [range, setrange] = useState([gt, it]);
  useEffect(() => {
    if (state.SideBarFiles.SideBarFile == "Approve Request") {
      dispatch(setTheFROMDATELIST(it));
      dispatch(setTheTODATELISTINDASH(it));
    }
  }, [state.SideBarFiles.SideBarFile]);

  const [range, setrange] = useState(
    state.SideBarFiles.SideBarFile == "Overview"
      ? [
          state.EmployeeVerificationsNeed.FROMDATE,
          state.EmployeeVerificationsNeed.TODATE,
        ]
      : state.SideBarFiles.SideBarFile == "Onboard Overview"
      ? [
          state.EmployeeVerificationsNeed.ONboardFROMDATE,
          state.EmployeeVerificationsNeed.ONboardTODATE,
        ]
      // : [it, gt]
      :
      state.EmployeeVerificationsNeed.employeelistFROMDATE == ""?


      []:
      [it, gt]


  );
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);

  const [datas, setData] = useState(
    state.SideBarFiles.SideBarFile == "Overview"
      ? {
          zone: state.ClientBranchIDs.EmployeeZone.value,
          state: state.ClientBranchIDs.EmployeeListState.value,
          region: state.ClientBranchIDs.EmployeeRegion.value,
        }
      : state.SideBarFiles.SideBarFile == "Onboard Overview"
      ? {
          zone: state.ClientBranchIDs.Attendacen_Zone.value,
          state: state.ClientBranchIDs.Attendance_State.value,
          region: state.ClientBranchIDs.Attendance_Region.value,
        }
      : {
          zone:  state.ClientBranchIDs.Employeeapprove_Zone.value,
          state: state.ClientBranchIDs.Employeeapprove_State.value,
          region: state.ClientBranchIDs.Employeeapprove_Region.value,
        }
  );

 
  const [multiselect, setMuliselect] = useState(
    state.SideBarFiles.SideBarFile == "Overview"
      ? [
          //  { value: "", label: "All" }

          state.ClientBranchIDs.EmployeeListState,
        ]
      :
      
       state.SideBarFiles.SideBarFile == "Onboard Overview"

      ?
      [state.ClientBranchIDs.Attendance_State]

      :

      [state.ClientBranchIDs.Employeeapprove_State]


  );
  const [multiselect1, setMuliselect1] = useState(
    state.SideBarFiles.SideBarFile == "Overview"
      ? [
          // { value: "", label: "All" },
          state.ClientBranchIDs.EmployeeRegion,
        ]
      : 
      state.SideBarFiles.SideBarFile == "Onboard Overview"

      ?
      [
          // { value: "", label: "All" },
          state.ClientBranchIDs.Attendance_Region,
        ]

        :
        [state.ClientBranchIDs.Employeeapprove_Region]



  );
  const [multiselect3, setMuliselect3] = useState(
    state.SideBarFiles.SideBarFile == "Overview"
      ? [
          // { value: "", label: "All" },
          state.ClientBranchIDs.EmployeeZone,
        ]
      :
      state.SideBarFiles.SideBarFile == "Onboard Overview"
?

      [state.ClientBranchIDs.Attendacen_Zone]
      :
      [state.ClientBranchIDs.Employeeapprove_Zone]

      
  );

  const [nameList5, setOptions5] = useState([]);


  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch:""
  };

  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
 
 if(state.SideBarFiles.SideBarFile == "Overview"){
  dispatch(setTheEmployeeregionName(selectedVal));
  dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));


 }
      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceregionObject(selectedVal));

        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }


      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproverequestRegionObject(selectedVal));

        dispatch(setTheApproveRequestZoneObject({ value: "", label: "ALL" }));
      }


      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));

        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }


      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproverequestRegionObject({ value: "", label: "ALL" }));

        dispatch(setTheApproveRequestZoneObject({ value: "", label: "ALL" }));
      }



      if(state.SideBarFiles.SideBarFile == "Overview"){ 

 


      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      }
      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setdtPageindex(1);

    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });
      if(state.SideBarFiles.SideBarFile == "Overview"){ 


      dispatch(setTheEmployeeZoneName(selectedVal));

      }
      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceZoneObject(selectedVal));
      }


      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproveRequestZoneObject(selectedVal));
      }

    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });
      if(state.SideBarFiles.SideBarFile == "Overview"){ 

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      }
      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproveRequestZoneObject({ value: "", label: "ALL" }));
      }

      setMuliselect3({ value: "", label: "ALL" });
    }
  };

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));

      setData({
        ...datas,
        state: selectedVal.value,
         region:"",
         zone:""
      });
if(state.SideBarFiles.SideBarFile == "Overview"){ 
      dispatch(setTheEmployeeeStateName(selectedVal));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

}
      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceStateObject(selectedVal));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));

        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }

      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproveRequestStateObject(selectedVal));
        dispatch(setTheApproverequestRegionObject({ value: "", label: "ALL" }));

        dispatch(setTheApproveRequestZoneObject({ value: "", label: "ALL" }));
      }
      setClients("");
dispatch(getSingleEmployeeActions(""))


    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      dispatch(getSingleEmployeeActions(""))

      setClients("");

      if (state.SideBarFiles.SideBarFile == "Approve Request") {
        dispatch(setTheApproveRequestStateObject({ value: "", label: "ALL" }));
        dispatch(setTheApproverequestRegionObject({ value: "", label: "ALL" }));

        dispatch(setTheApproveRequestZoneObject({ value: "", label: "ALL" }));
      }
      if(state.SideBarFiles.SideBarFile == "Overview"){ 


      dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
      }

      if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
        dispatch(setTheAttendanceStateObject({ value: "", label: "ALL" }));
        dispatch(setTheAttendanceregionObject({ value: "", label: "ALL" }));

        dispatch(setTheAttendanceZoneObject({ value: "", label: "ALL" }));
      }
    }
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch);

      }
    },
    500,
    [SearchDebounance]
  );

///-----State----Input Changes
const handleInputChange = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    stateSearch: Val,

  });

};

///---Region-----------------
const handleInputRegion = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    regionSearch: Val,
  });
};
///----Zone---Name
const handleInputZone = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    zoneSearch:Val,
  });
};

  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [searchBranch , datas]);

  // const debouncedClientBased = useMemo(
  //   () =>
  //     _.debounce((e) => {
  //       const payload = {
  //         search: searchBranch,
  //         page_size: 30,
  //         page: 1,
  //         data: data,
  //       };
  //       dispatch(setClientBranchSearchAction(payload));
  //     }, 500),
  //   []
  // );

  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch:e
    })
  };
  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);

  useEffect(() => {
    if (state.DashboardCall.DashboardCLientList != null) {
      setClients(state.DashboardCall.DashboardCLientList.value);
      setClientName(state.DashboardCall.DashboardCLientList.label);
    }
  }, [state.DashboardCall.DashboardCLientList]);

  //--EXCELSHEET----UPLOAD----------------

  const [ExcelSheeTFORKYCPopup, setExcelSheetFORKYCPopup] = useState(false);
  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });

  ////---Get--sub role--
  const UserData = useSelector((state) => state.users.UserData);

  useEffect(() => {
    if (state.users.UserData.data != undefined) {
    }
    if (UserData.session) {
      if (UserData.data != undefined && UserData.data != null) {
        setSubRoleList(UserData.data.sub_role);
      }
    }
  }, [UserData]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  ////--_FIlter--------------------------

  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    // { value: state.NumberCounts.Option2, label: "Completed" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ]; 
   console.log(options ,"adasdoptions");
   
  const [sel, setSelected] = useState();
  ////----Count---Based------Rendered----
  const [Counting, setCounting] = useState(1);
  const [selectDisplay, setDisplay] = useState([]);
  const FileterState = {
    // is_pending: false,
    // is_decline: false,
    // approved: false,

    // is_pending: "",
    // is_decline: "",
    // approved: "",
     is_pending:state.NeededdatasListed.StatusFilter.is_pending, 
     is_decline:state.NeededdatasListed.StatusFilter.is_decline,
     approved:state.NeededdatasListed.StatusFilter.approved,
  };
  const [RenderCounts, SetRenderCounts] = useState();
  const [selectVal, SetSelectval] = useState(FileterState);
  const [place, SetPlace] = useState("");
//  console.log(state.NumberCounts.Options , "0873102730Options" , state.NumberCounts.namerednder , options);
  useEffect(() => {
    //  if(state.ClientBranchIDs.DashboardIDs == 3  ){
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options[0]));
      SetPlace("All");
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
       const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved: "",}
       
      dispatch(setTheStatusFilter(StatusFilter))
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Approved");

      SetSelectval({
        ///Completed
        ...selectVal,
        // is_pending: false,
        // is_decline: false,
        // approved: "",
        is_pending: "",
        is_decline: "",
        approved: true,
      });

      const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved:true}
       
      dispatch(setTheStatusFilter(StatusFilter))


    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Decline");

      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: "",
        is_decline: true,
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))

      
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[1]));
      SetPlace("Pending");
      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: true,
        is_decline: "",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))


    }
    // }
  }, [state.NumberCounts.namerednder]);
  ///console.log(state.NumberCounts.Options, "listouted");
  ///chnage--subrole values
  const HandleEMprole = (e) => {
    setSubroleSelected(e);
    // dispatch(SetDashboards(4))
    setdtPageindex(1);
    setroleIDs(e.value);
     console.log(e ,"aposdpaosid");
     
    if (e != null) {
      

      // if (state.ClientBranchIDs.DashboardIDs == 3) {
      if (e.value == 0) {
        dispatch(setDropDownRenders(""));

        setPayrollFilter({
          ...PayRollFilter,
          // is_pending: true,
          // is_decline: true,
          // payroll_approved: false,

          dash_return_type: "payroll",
          inside_type: "all",
          kyc_completed:""
        });
      }

   else   if (e.value == 2) {
        dispatch(setDropDownRenders("Decline"));

        setPayrollFilter({
          ...PayRollFilter,
          // is_pending: true,
          // is_decline: true,
          // payroll_approved: false,

          dash_return_type: "payroll",
          inside_type: "decline",
          kyc_completed:""
        });
      } else if (e.value == 3) {
        dispatch(setDropDownRenders("Approved"));
        setPayrollFilter({
          ...PayRollFilter,
          // is_decline: "",
          // payroll_approved: true,
          // is_pending: true,
          dash_return_type: "payroll",
          inside_type: "approved",
          kyc_completed:""
        });
      } else if (e.value == 1) {
        dispatch(setDropDownRenders("Pending"));

        setPayrollFilter({
          ...PayRollFilter,

          dash_return_type: "payroll",
          inside_type: "pending",
          kyc_completed:""
        });
      }

     else if (e.value == 4) {
      dispatch(setDropDownRenders("kyc_completed"));

      setPayrollFilter({
        ...PayRollFilter,

        dash_return_type: "payroll",
        inside_type: "kyc_completed",
        kyc_completed:true,
      });
    }
    } else if (e == null) {
      dispatch(setDropDownRenders(""));
      setPayrollFilter({
        ...PayRollFilter,
        dash_return_type: "payroll",
        inside_type: "all",
        kyc_completed:""
      });
    }
  };

  ///=------Status----Render----
  useEffect(() => {
    console.log(state.ClientBranchIDs.DashboardIDs, "without Branch List");
    setRenderStatus(state.ClientBranchIDs.DashboardIDs);
  }, [state.ClientBranchIDs.DashboardIDs]);

   console.log(state.ClientBranchIDs.DashboardIDs , "state.NumberCounts.namerednder", state.NumberCounts.namerednder,
    state.EmployeeListPresons.Inquriy
   ) ;
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
          if (
            // state.ClientBranchIDs.SUBROLE == 3 && 
            state.ClientBranchIDs.DashboardIDs == 2) {
      if (state.NumberCounts.namerednder == "Decline") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,
          // ids: state.ClientBranchIDs.SingelEmployeelistes,
          // client: Client == undefined ? "" : Client,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",
          // RenderStatus: RenderStatus,
          // payroll_approved: roleIds,
          // SubRoleList: SubRoleList,

          from_date: range[0],
          is_pending: "",
          is_decline: true,
          approved: "",
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
      }

      if (state.NumberCounts.namerednder == "Pending") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // is_pending: true,
          // is_decline: "",
          // approved: "",
          is_pending: true,
          is_decline: false,
          approved: "",
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
      }

      if (state.NumberCounts.namerednder == "completed" || state.NumberCounts.namerednder == "Approved") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // is_pending: false,
          // is_decline: false,
          // approved: "",
          is_pending: "",
          is_decline: "",
          approved: true,
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
      }

      if (state.NumberCounts.namerednder == "") {
        SetPlace("ALL");
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],

          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
      }
    }

    //---for the----payrolll
     if ( 
      // state.ClientBranchIDs.SUBROLE == 3 && 
      state.ClientBranchIDs.DashboardIDs == 3 ) {
      if (state.NumberCounts.namerednder == "Decline") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,
          // ids: state.ClientBranchIDs.SingelEmployeelistes,
          // client: Client == undefined ? "" : Client,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",
          from_date: range[0],
          // is_pending: true,
          // is_decline: true,
          // payroll_approved: false,
          to_date: range[1],
          range: true,
          dash_return_type: "payroll",
          inside_type: "decline",
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(2);
        setSubroleSelected({ value: "2", label: "Decline" });
      }

      if (state.NumberCounts.namerednder == "Pending") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // is_pending: true,
          // payroll_approved: false,
          dash_return_type: "payroll",
          inside_type: "pending",
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(1);
        setSubroleSelected({ value: "1", label: "Pending" });
      }

      if (state.NumberCounts.namerednder == "completed" || state.NumberCounts.namerednder == "kyc_completed") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // payroll_approved: true,
          // is_pending: true,
          // dash_return_type: "payroll",
          // inside_type: "approved",
          dash_return_type: "payroll",
        inside_type: "kyc_completed",
        kyc_completed:true,
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(3);
        setSubroleSelected({ value: "4", label: "kyc Completed" });
      }
      if (state.NumberCounts.namerednder == "Approved" ) {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // payroll_approved: true,
          // is_pending: true,
          // dash_return_type: "payroll",
          // inside_type: "approved",
          dash_return_type: "payroll",
          inside_type: "approved",
          kyc_completed:"",
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(3);
        setSubroleSelected({ value: "3", label: "Approved" });
      }


      if (state.NumberCounts.namerednder == "") {
        SetPlace("ALL");
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],

          to_date: range[1],
          range: true,
          dash_return_type: "payroll",
          inside_type: "all",
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(3);
      }

    }

    ///---rm
    if (
      //  state.ClientBranchIDs.SUBROLE == 3 &&
        state.ClientBranchIDs.DashboardIDs == 4 ) {
      if (state.NumberCounts.namerednder == "Decline") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,
          // ids: state.ClientBranchIDs.SingelEmployeelistes,
          // client: Client == undefined ? "" : Client,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",
          from_date: range[0],
          // is_pending: true,
          // is_decline: true,
          // payroll_approved: false,
          to_date: range[1],
          range: true,
          dash_return_type: "rm",
          inside_type: "decline",
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(2);
        setSubroleSelected({ value: "2", label: "Decline" });
      }

      if (state.NumberCounts.namerednder == "Pending") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // is_pending: true,
          // payroll_approved: false,
          dash_return_type: "rm",
          inside_type: "pending",
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(1);
        setSubroleSelected({ value: "1", label: "Pending" });
      }

      if (state.NumberCounts.namerednder == "completed" || state.NumberCounts.namerednder == "Approved") {
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],
          // payroll_approved: true,
          // is_pending: true,
          dash_return_type: "rm",
          inside_type: "approved",

          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(3);
        setSubroleSelected({ value: "3", label: "Completed" });
      }

      if (state.NumberCounts.namerednder == "") {
        SetPlace("ALL");
        const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          from_date: range[0],

          to_date: range[1],
          range: true,
          dash_return_type: "rm",
          inside_type: "all",
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);
        setroleIDs(3);
      }

    }
    if ( 
      // state.ClientBranchIDs.SUBROLE == 3 && 
      state.ClientBranchIDs.DashboardIDs == 1 ) {
     const payloads = {
          search: search,
          page_size: 20,
          page: dtpageindex,
          // ids: state.ClientBranchIDs.SingelEmployeelistes,
          // client: Client == undefined ? "" : Client,

          client:
            state.ClientBranchIDs.SingelEmployeelistes != undefined
              ? state.ClientBranchIDs.SingelEmployeelistes
              : "",

          // is_pending: !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved && selectVal.approved != "" ?   "": selectVal.is_pending ,
          // is_decline: !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved   && selectVal.approved != ""  ?   "": selectVal.is_decline,
          // approved:  !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved  ?   "": selectVal.approved ,

          is_pending: selectVal.is_pending,
          is_decline: selectVal.is_decline,
          approved: selectVal.approved,

          from_date: range[0],
          to_date: range[1],
          range: true,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
        };
        setTimeout(() => {
          dispatch(getEmployeeListPersonsListed(payloads));
        }, 250);

    }

    //---for the----RM
    
    // if (
    //   state.ClientBranchIDs.SUBROLE == 1
    //   //  &&
    //   // state.ClientBranchIDs.SUBROLE != 0
    //   //  &&

    //   // state.ClientBranchIDs.DashboardIDs == 4
    // ) {
    //   if (state.NumberCounts.namerednder == "Decline") {
    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,
    //       // ids: state.ClientBranchIDs.SingelEmployeelistes,
    //       // client: Client == undefined ? "" : Client,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",
    //       from_date: range[0],
    //       // is_pending: true,
    //       // is_decline: true,
    //       // payroll_approved: false,
    //       to_date: range[1],
    //       range: true,
    //       dash_return_type: "rm",
    //       inside_type: "decline",
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);
    //     setroleIDs(2);
    //     setSubroleSelected({ value: "2", label: "Decline" });
    //   }

    //   if (state.NumberCounts.namerednder == "Pending") {
    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",

    //       from_date: range[0],
    //       // is_pending: true,
    //       // payroll_approved: false,
    //       dash_return_type: "rm",
    //       inside_type: "pending",
    //       to_date: range[1],
    //       range: true,
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);
    //     setroleIDs(1);
    //     setSubroleSelected({ value: "1", label: "Pending" });
    //   }

    //   if (state.NumberCounts.namerednder == "completed") {
    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",

    //       from_date: range[0],
    //       // payroll_approved: true,
    //       // is_pending: true,
    //       dash_return_type: "rm",
    //       inside_type: "approved",

    //       to_date: range[1],
    //       range: true,
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);
    //     setroleIDs(3);
    //     setSubroleSelected({ value: "3", label: "Completed" });
    //   }

    //   if (state.NumberCounts.namerednder == "") {
    //     SetPlace("ALL");
    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",

    //       from_date: range[0],

    //       to_date: range[1],
    //       range: true,
    //       dash_return_type: "rm",
    //       inside_type: "all",
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);
    //     setroleIDs(3);
    //   }
    // } 
    // else if (
    //   // state.ClientBranchIDs.DashboardIDs == 1 &&
    //   state.ClientBranchIDs.SUBROLE != 0 &&
    //   state.ClientBranchIDs.SUBROLE != 1
    //   &&
    //   state.ClientBranchIDs.SUBROLE == 3

    // ) {
    //           console.log(state.ClientBranchIDs.SUBROLE, "jojijojj");

    //   if (state.ClientBranchIDs.SUBROLE == 0) {
    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,
    //       // ids: state.ClientBranchIDs.SingelEmployeelistes,
    //       // client: Client == undefined ? "" : Client,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",
    //       // RenderStatus: RenderStatus,
    //       // payroll_approved: roleIds,
    //       // SubRoleList: SubRoleList,

    //       is_pending: PayRollFilter.is_pending,
    //       is_decline: PayRollFilter.is_decline,
    //       payroll_approved: PayRollFilter.payroll_approved,

    //       from_date: range[0],
    //       // is_pending: selectVal.is_pending,
    //       // is_decline: selectVal.is_decline,
    //       // approved: selectVal.approved,
    //       to_date: range[1],
    //       range: true,
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     // console.log(state.ClientBranchIDs.SingelEmployeelistes, "jojijojj");
    //     // dispatch(getEmployeeListPersonsListed(payloads));
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);

    //     SetPlace("ALL");
    //   }
    //    else {

    //     const payloads = {
    //       search: search,
    //       page_size: 20,
    //       page: dtpageindex,
    //       // ids: state.ClientBranchIDs.SingelEmployeelistes,
    //       // client: Client == undefined ? "" : Client,

    //       client:
    //         state.ClientBranchIDs.SingelEmployeelistes != undefined
    //           ? state.ClientBranchIDs.SingelEmployeelistes
    //           : "",

    //       // is_pending: !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved && selectVal.approved != "" ?   "": selectVal.is_pending ,
    //       // is_decline: !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved   && selectVal.approved != ""  ?   "": selectVal.is_decline,
    //       // approved:  !selectVal.is_pending && !selectVal.is_decline && !selectVal.approved  ?   "": selectVal.approved ,

    //       is_pending: selectVal.is_pending,
    //       is_decline: selectVal.is_decline,
    //       approved: selectVal.approved,

    //       from_date: range[0],
    //       to_date: range[1],
    //       range: true,
    //       state: datas.state,
    //       region: datas.region,
    //       zone: datas.zone,
    //     };
    //     setTimeout(() => {
    //       dispatch(getEmployeeListPersonsListed(payloads));
    //     }, 250);
    //   }
    // }


    //  else if (
    //   state.ClientBranchIDs.SUBROLE == 0 
    //   // &&
    //   // state.ClientBranchIDs.DashboardIDs != 3
    // ) {
    //   const payloads = {
    //     search: search,
    //     page_size: 20,
    //     page: dtpageindex,

    //     client:
    //       state.ClientBranchIDs.SingelEmployeelistes != undefined
    //         ? state.ClientBranchIDs.SingelEmployeelistes
    //         : "",
    //     from_date: range[0],

    //     // dash_return_type: PayRollFilter.dash_return_type,
    //     // inside_type: PayRollFilter.inside_type,
    //     // kyc_completed:PayRollFilter.kyc_completed,
    //     dash_return_type:     "payroll",
    //     inside_type:  state.NumberCounts.namerednder =="Approved" || state.NumberCounts.namerednder == "Approve" ? "approved":

    //     state.NumberCounts.namerednder == "Decline" ?

    //     "decline":state.NumberCounts.namerednder == "Pending" ?

    //     "pending":state.NumberCounts.namerednder == "" ?
    //     "all" : state.NumberCounts.namerednder == "kyc_completed" || state.NumberCounts.namerednder == "completed" && "kyc_completed",

    //     kyc_completed:state.NumberCounts.namerednder == "kyc_completed"|| state.NumberCounts.namerednder == "completed" ? true : "",








    //     to_date: range[1],
    //     range: true,
    //     state: datas.state,
    //     region: datas.region,
    //     zone: datas.zone,
    //   };
    //   setTimeout(() => {
    //     dispatch(getEmployeeListPersonsListed(payloads));
    //   }, 250);


      
    // } else if (
    //   state.ClientBranchIDs.SUBROLE == 1 
    //   // &&
    //   // state.ClientBranchIDs.DashboardIDs != 4
    // ) {
    //   const payloads = {
    //     search: search,
    //     page_size: 20,
    //     page: dtpageindex,

    //     client:
    //       state.ClientBranchIDs.SingelEmployeelistes != undefined
    //         ? state.ClientBranchIDs.SingelEmployeelistes
    //         : "",
    //     from_date: range[0],

    //     // dash_return_type: RmFIlters.dash_return_type,
    //     // inside_type: RmFIlters.inside_type,

    //     dash_return_type:"rm",
    //     inside_type:  state.NumberCounts.namerednder == "completed" || state.NumberCounts.namerednder =="Approved" ? "approved":

    //     state.NumberCounts.namerednder == "Decline" ?

    //     "decline":state.NumberCounts.namerednder == "Pending" ?

    //     "pending":
    //     "all" ,




    //     range: true,
    //     to_date: range[1],
    //     state: datas.state,
    //     region: datas.region,
    //     zone: datas.zone,
    //   };
    //   setTimeout(() => {
    //     dispatch(getEmployeeListPersonsListed(payloads));
    //   }, 250);
    // }

  }


  }, [
    // roleIds, SubRoleList,

    dtpageindex,
    range,
    // Client,


    state.ClientBranchIDs.DashboardIDs,
    state.NumberCounts.namerednder,
    state.ClientBranchIDs.SingelEmployeelistes,
    datas,
    search
    
  ]);
   console.log(state.ClientBranchIDs.SUBROLE ,"SUBROLE" ,state.ClientBranchIDs.DashboardIDs );
   

  useEffect(() => {
    if (
      state.EmployeeListPresons.EmployeePersons != undefined &&
      state.EmployeeListPresons.EmployeePersons != null &&
      state.EmployeeListPresons.EmployeePersons.inquiry_data != undefined &&
      state.EmployeeListPresons.EmployeePersons.inquiry_data != null &&
      state.EmployeeListPresons.EmployeePersons.inquiry_data != []
    ) {
      setdatas(state.EmployeeListPresons.EmployeePersons.inquiry_data);
    }
  }, [state.EmployeeListPresons.EmployeePersons]);

  useEffect(() => {
    if (state.ClientBranchIDs.SingelEmployeelistes) {
      setBranchName(state.EmployeeVerificationsNeed.BranchName);
      setZone(state.EmployeeVerificationsNeed.Zone);
      setInquiry(state.EmployeeVerificationsNeed.EmployeeRequst);
    }
  }, [state.ClientBranchIDs.SingelEmployeelistes]);
  // console.log(
  //   state.ClientBranchIDs.DashboardIDs,
  //   "Dashboar8237dIDs",
  //   state.ClientBranchIDs.SUBROLE,
  //   state.NumberCounts.namerednder
  // );

  // Debounce the search function
  // const debouncedSearch = useMemo(
  //   () =>
  //     _.debounce((e) => {
  //       // console.log("Searching for:", e);

  //       setsearch(e);


  //     }, 400),
  //   []
  // );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    setsearch(e);


    // debouncedSearch(e);
  }

  // React.useEffect(() => {
  //   return () => {
  //     debouncedSearch.cancel();
  //     // debouncedClientBased.cancel();
  //   };
  // }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
     console.log(arg , "34982374087arg");
    setdtPageindex(arg);
  };

 useEffect(()=>{
  dispatch(setEditableActions(1));
 },[])
  // console.log( "034980398" , dtpageindex);
  const handleEmployeeDetails = (id) => {
    // dispatch(setTheUser_ID(id.id));
    dispatch(setTheUser_ID(id.user_id.id));

    dispatch(setEditableActions(1));
    console.log(state.SideBarFiles.SideBarFile, "isfsd", id);
    dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
    dispatch(SetISPendingDetails(id.is_pending));
    dispatch(SetStatusBTN(false));
    // dispatch(setTheemployeeRoleId(user_id)); ///---role----id
    dispatch(setTheAllFormPdf(id.create_employee));
    dispatch(setTheRoleObjects(
      {value:id.user_id.user_role.id, label: id.user_id.user_role.role}
    ))
dispatch(settheJobinfoBranchEmployeeProfile({
  value: id?.client_id?.id ?? "",
  label: id?.client_id?.branch_code
    ? `${id.client_id.branch_code} - ${id.client_id.client_name ?? ""}`
    : `${id?.client_id?.client_name ?? ""}`,
  is_reliever: id?.client_id?.is_reliever ?? false
}));



    dispatch(setTheBranchoptionsFieldAgent({
      value: id?.client_id?.id ?? "",
      label: id?.client_id?.branch_code
        ? `${id.client_id.branch_code} - ${id.client_id.client_name ?? ""}`
        : `${id?.client_id?.client_name ?? ""}`,
      is_reliever: id?.client_id?.is_reliever ?? false
    }));///client and role objects


    dispatch(setTheemployeeRoleId(id.user_id.user_role.id));



    dispatch(
      setTheUserObjects({ value: id.user_id.id, label: id.user_id.first_name })
    );
 dispatch(settheJobinfoBranchEmployeeProfile({
  value: id?.client_id?.id ?? "",
  label: id?.client_id?.branch_code
    ? `${id.client_id.branch_code} - ${id.client_id.client_name ?? ""}`
    : `${id?.client_id?.client_name ?? ""}`,
  is_reliever: id?.client_id?.is_reliever ?? false
}));



    dispatch(SettheBracnhId(id.client_id.id))
    // if (
    //   state.SideBarFiles.SideBarFile == "Overview" ||
    //   state.SideBarFiles.SideBarFile == "Onboard Overview"
    // ) {
    //   dispatch(SetDashboards(2));
    // }

    if (
      state.SideBarFiles.SideBarFile == "Approve Request" ||
      state.SideBarFiles.SideBarFile == "Onboard" ||
      // state.SideBarFiles.SideBarFile == "DashBoard"
      state.SideBarFiles.SideBarFile == "Overview" ||
      state.SideBarFiles.SideBarFile == "Onboard Overview"
    ) {
      navigate("/employeeprofile");
    } else if (state.SideBarFiles.SideBarFile == "Site Transfer") {
      navigate("/sitetransfer");
    } else if (state.SideBarFiles.SideBarFile == "Black list") {
      navigate("/blocklist");
    }

    // window.location.href = "/employeeprofile";
  };

  // const capitalizeFirstLetter = (Letter) => {
  //   return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  // };
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const columns = useMemo(
    () =>
      [
       
       {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
//        {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
    {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },

        {
          Header: "Employee Name",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <div
                  className="UserName"
                  style={{ cursor: "pointer" }}
                >
                  {/* {row.row.original.user_id != undefined &&
                  row.row.original.user_id != null &&
                  row.row.original.user_id.user_image != undefined &&
                  row.row.original.user_id.user_image != null &&
                  row.row.original.user_id.user_image.media_url != undefined &&
                  row.row.original.user_id.user_image.media_url != null ? (
                    <div className="ProfilImg">
                      <img
                        src={row.row.original.user_id.user_image.media_url}
                      />
                    </div>
                  ) : (
                    <div className="ProfilImg">
                      <img src={profile2} />
                    </div>
                  )} */}
                  <div className="">
                    {row.row.original.user_id != undefined && row.row.original.user_id != null &&
                    row.row.original.user_id != ""
                    &&
                    row.row.original.user_id.first_name != undefined && row.row.original.user_id.first_name != null 
                    &&
                    row.row.original.user_id.first_name !="" ? 
                    <span>
                      {capitalizeFirstLetter(
                        row.row.original.user_id.first_name
                      )}
                    </span>
                    : <>--</> }
                  </div>
                </div>
              </>
            );
          },
        },

//         {
//           Header: "Onboarder Details",
//           accessor: "",
//           Cell: (row) => {
//             return (
//               <>
//                 {row.row.original.approved_status != undefined &&
//                 row.row.original.approved_status != null &&
//                 row.row.original.approved_status != null &&
//                 row.row.original.approved_status != undefined &&
//                 row.row.original.approved_status.length > 0 &&
//                 row.row.original.approved_status != null ? (
//                   <div className="UserName">
//                     {row.row.original.approved_status.map((item)=>{
//                        console.log(item , "2364927364");
//                         if(item.user_type == "onboard"){

// console.log(item.create_user.email, "9839847198731982");

//                         }
//                     })}
//                     <span>
//                       {row.row.original.approved_status.map((item , index) => {
//                         return (
//                           <>
//                             <p>
//                               {item.user_type == "onboard" ? (
//                                 <>
//                                   {item.create_user.email != undefined &&
//                                     item.create_user.email != null &&
//                                     item.create_user.email}
//                                 </>
//                               ) : (
//                                 <></>
//                               )}
//                             </p>
//                           </>
//                         );
//                       })}



//                     </span>
//                   </div>
//                 ) : (
//                   <div className="UserName">
//                     <span>---</span>
//                   </div>
//                 )}
//               </>
//             );
//           },
//         },

{
  Header: "Onboarder Details",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const approvedStatus = row.row.original.approved_status;

    if (approvedStatus && approvedStatus.length > 0) {
      const onboarder = approvedStatus.find(
        (item) => item.user_type === "onboard"
      );

      if (onboarder && onboarder.create_user && onboarder.create_user.email) {
        return (
          <div className="UserName" 
            onMouseEnter={() => setShowTooltip(true)} 
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: 'relative' }} // Ensure the tooltip is positioned correctly
          >
            <span className="onboarder-email">
              {onboarder.create_user.email}
            </span>

            {/* Custom tooltip */}
            {showTooltip && (
              <div className="custom-tooltip">
                {onboarder.create_user.email}
              </div>
            )}
          </div>
        );
      }
    }

    return (
      <div className="UserName">
        <span>---</span>
      </div>
    );
  },
},


        {
          Header: "Mobile",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.user_id != null &&
                row.row.original.user_id.phone_number != null &&
                row.row.original.user_id.phone_number != "" &&
                row.row.original.user_id.phone_number != undefined ? (
                  <>
                    {row.row.original.user_id.phone_number != undefined ? (
                      <div className="UserName">
                        <span className="KYcRoles">{row.row.original.user_id.phone_number}</span>
                      </div>
                    ) : (
                      <div className="UserName">
                        <span className="KYcRoles">---</span>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="UserName">
                    <span  className="KYcRoles">{"----"}</span>
                  </div>
                )}
              </>
            );
          },
        },

        {
          Header: "Created date",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.created_at;
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <p
                   className="PTAGs"
                >
                  {`${
                    row.row.original.created_at.slice(0, 10) 
                    // +
                    // "  " +
                    // formattedTime
                  }`}
                </p>
              </>
            );
          },
        },

        // {
        //   Header: "Branch",
        //   accessor: "",
        //   Cell: (row) => {
        //     const [showTooltip, setShowTooltip] = useState(false);
        
        //     return (
        //       <>
        //         {row.row.original.client_id != null &&
        //         row.row.original.client_id != undefined &&
        //         row.row.original.client_id.client_name != "" &&
        //         row.row.original.client_id.client_name != undefined ? (
        //           <div className="UserName"
        //             onMouseEnter={() => setShowTooltip(true)}
        //             onMouseLeave={() => setShowTooltip(false)}
        //             style={{ position: 'relative' }} 
        //           >
        //             <span>
        //               {row.row.original.client_id.client_name.length > 12 ? (
        //                 <>
        //                   {row.row.original.client_id.client_name.slice(0, 12)}...
        //                 </>
        //               ) : (
        //                 <>{row.row.original.client_id.client_name}</>
        //               )}
        //             </span>
        
        //             {/* Custom tooltip */}
        //             {showTooltip && (
        //               <div className="custom-tooltip">
        //                 {row.row.original.client_id.client_name}
        //               </div>
        //             )}
        //           </div>
        //         ) : (
        //           <div className="UserName">
        //             <span>---</span>
        //           </div>
        //         )}
        //       </>
        //     );
        //   },
        // },        
{
  Header: "Branch",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const client = row?.row?.original?.client_id;
    const branchCode = client?.branch_code ?? "";
    const clientName = client?.client_name ?? "";

    // Full label for tooltip
    const fullLabel = branchCode
      ? `${branchCode} - ${clientName}`
      : clientName;

    // Short display (truncate client name only)
    const shortName =
      clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

    const shortLabel = branchCode
      ? `${branchCode} - ${shortName}`
      : shortName;

    return (
      <>
        {client && clientName ? (
          <div
            className="UserName"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: "relative" }}
          >
            <span>{shortLabel}</span>

            {showTooltip && (
              <div className="custom-tooltip">{fullLabel}</div>
            )}
          </div>
        ) : (
          <div className="UserName">
            <span>---</span>
          </div>
        )}
      </>
    );
  },
},

        // SubRoleList != 0 &&
        //   SubRoleList != 1 &&
        //   SubRoleList != 3 && {
        //     Header: "Onboarding Status",
        //     accessor: "",
        //     Cell: (row) => {
        //       return (
        //         <>
        //           {/* //----For Payroll Pending */}
        //           {!row.row.original.payroll_approved &&
        //           row.row.original.is_pending &&
        //           row.row.original.create_employee ? (
        //             <>
        //               <span style={{ color: "green" }}>
        //                 {" "}
        //                 Awaiting for payroll
        //               </span>
        //             </>
        //           ) : null}

        //           {/* -----RM---pending */}
        //           {(row.row.original.payroll_approved &&
        //             !row.row.original.is_pending &&
        //             !row.row.original.is_decline &&
        //             row.row.original.job_description == null) ||
        //           (row.row.original.job_description == undefined &&
        //             row.row.original.create_employee) ? (
        //             <>
        //               <span style={{ color: "green" }}>
        //                 Awaiting for RM approval
        //               </span>
        //             </>
        //           ) : null}

        //           {!row.row.original.is_pending &&
        //           !row.row.original.is_decline &&
        //           row.row.original.job_description != undefined &&
        //           row.row.original.job_description.letter_id != undefined &&
        //           row.row.original.job_description.letter_id.media_url ? (
        //             <>
        //               <span style={{ color: "green" }}>KYC Completed</span>
        //             </>
        //           ) : row.row.original.payroll_approved &&
        //             !row.row.original.is_pending &&
        //             !row.row.original.is_decline ? (
        //             <>
        //               {/* -------RM---Approve--------------- */}

        //               <span style={{ color: "green" }}>RM Approved</span>
        //             </>
        //           ) : null}

        //           {/* -------Payroll---Approve--------------- */}

        //           {row.row.original.payroll_approved &&
        //           row.row.original.is_pending ? (
        //             // &&
        //             // row.row.original.is_decline
        //             <>
        //               <span style={{ color: "green" }}>Payroll Approved</span>
        //             </>
        //           ) : null}

        //           {/* {!row.row.original.create_employee ? (
        //       <>
        //         <span style={{ color: "red" }}>Form is not Filled</span>
        //       </>
        //     ) : null} */}

        //           {/* -------RM---Approve--------------- */}
        //           {/*
        //     {(row.row.original.payroll_approved &&
        //       !row.row.original.is_pending &&
        //       !row.row.original.is_decline) ||
        //     row.row.original.job_description == undefined ||
        //     row.row.original.job_description == null  ? (
        //       <>
        //         <span style={{ color: "green" }}>RM Approved</span>
        //       </>
        //     ) : null} */}

        //           {/* //-----form not filled */}

        //           {!row.row.original.create_employee ? (
        //             //&&
        //             //  ( row.row.original.is_declaration_form != null &&
        //             //   !row.row.original.is_declaration_form) ||
        //             // (row.row.original.is_basic_info != null &&
        //             //   !row.row.original.is_basic_info) ||
        //             // !row.row.original.is_esi_form ||
        //             // (row.row.original.is_id_verification != null &&
        //             //   row.row.original.is_id_verification != null &&
        //             //   !row.row.original.is_id_verification) ||
        //             // (row.row.original.is_previous_employee != null &&
        //             //   !row.row.original.is_previous_employee) ||
        //             // (row.row.original.is_education_detail != null &&
        //             //   !row.row.original.is_education_detail) ||
        //             // (row.row.original.is_bank_details != null &&
        //             //   !row.row.original.is_bank_details) ||
        //             // (row.row.original.is_job_description != null &&
        //             //   !row.row.original.is_job_description) ||
        //             // (row.row.original.is_address_details != null &&
        //             //   !row.row.original.is_address_details)

        //             <>
        //               <span style={{ color: "green" }}>Kyc Pending</span>
        //             </>
        //           ) : null}
        //         </>
        //       );
        //     },
        //   },

        // SubRoleList == 1 && {
        //   Header: "Onboarding Status",
        //   accessor: "",
        //   Cell: (row) => {
        //     return (
        //       <>
        //         {/* //----For Payroll Pending */}
        //         {!row.row.original.payroll_approved &&
        //         row.row.original.is_pending &&
        //         row.row.original.create_employee ? (
        //           <>
        //             <span style={{ color: "green" }}>
        //               {" "}
        //               Awaiting for payroll
        //             </span>
        //           </>
        //         ) : null}

        //         {/* -----RM---pending */}
        //         {(row.row.original.payroll_approved &&
        //           !row.row.original.is_pending &&
        //           !row.row.original.is_decline &&
        //           row.row.original.job_description == null) ||
        //         (row.row.original.job_description == undefined &&
        //           row.row.original.create_employee) ? (
        //           <>
        //             <span style={{ color: "green" }}>
        //               Awaiting for RM approval
        //             </span>
        //           </>
        //         ) : null}

        //         {!row.row.original.is_pending &&
        //         !row.row.original.is_decline &&
        //         row.row.original.job_description != undefined &&
        //         row.row.original.job_description.letter_id != undefined &&
        //         row.row.original.job_description.letter_id.media_url ? (
        //           <>
        //             <span style={{ color: "green" }}>KYC Completed</span>
        //           </>
        //         ) : row.row.original.payroll_approved &&
        //           !row.row.original.is_pending &&
        //           !row.row.original.is_decline ? (
        //           <>
        //             {/* -------RM---Approve--------------- */}

        //             <span style={{ color: "green" }}>RM Approved</span>
        //           </>
        //         ) : null}

        //         {/* -------Payroll---Approve--------------- */}

        //         {row.row.original.payroll_approved &&
        //         row.row.original.is_pending ? (
        //           <>
        //             <span style={{ color: "green" }}>
        //               Awaiting for RM approval
        //             </span>
        //           </>
        //         ) : null}

        //         {!row.row.original.create_employee ? (
        //           <>
        //             <span style={{ color: "green" }}>Kyc Pending</span>
        //           </>
        //         ) : null}
        //       </>
        //     );
        //   },
        // },

        // SubRoleList == 0 && {
        //   Header: "Onboarding Status",
        //   accessor: "",
        //   Cell: (row) => {
        //     return (
        //       <>
        //         {/* //----For Payroll Pending */}
        //         {!row.row.original.payroll_approved &&
        //         row.row.original.is_pending &&
        //         row.row.original.create_employee ? (
        //           <>
        //             <span style={{ color: "green" }}>
        //               {" "}
        //               Awaiting for payroll
        //             </span>
        //           </>
        //         ) : null}

        //         {/* -----RM---pending */}
        //         {(row.row.original.payroll_approved &&
        //           !row.row.original.is_pending &&
        //           !row.row.original.is_decline &&
        //           row.row.original.job_description == null) ||
        //         (row.row.original.job_description == undefined &&
        //           row.row.original.create_employee) ? (
        //           <>
        //             <span style={{ color: "green" }}>
        //               Awaiting for RM approval
        //             </span>
        //           </>
        //         ) : null}

        //         {!row.row.original.is_pending &&
        //         !row.row.original.is_decline &&
        //         row.row.original.job_description != undefined &&
        //         row.row.original.job_description.letter_id != undefined &&
        //         row.row.original.job_description.letter_id.media_url ? (
        //           <>
        //             <span style={{ color: "green" }}>KYC Completed</span>
        //           </>
        //         ) : row.row.original.payroll_approved &&
        //           !row.row.original.is_pending &&
        //           !row.row.original.is_decline ? (
        //           <>
        //             {/* -------RM---Approve--------------- */}

        //             <span style={{ color: "green" }}>RM Approved</span>
        //           </>
        //         ) : null}

        //         {/* -------Payroll---Approve--------------- */}

        //         {row.row.original.payroll_approved &&
        //         row.row.original.is_pending ? (
        //           // &&
        //           // row.row.original.is_decline
        //           <>
        //             <span style={{ color: "green" }}>Payroll Approved</span>
        //           </>
        //         ) : null}

        //         {/* {!row.row.original.create_employee ? (
        //     <>
        //       <span style={{ color: "red" }}>Form is not Filled</span>
        //     </>
        //   ) : null} */}

        //         {/* -------RM---Approve--------------- */}
        //         {/*
        //   {(row.row.original.payroll_approved &&
        //     !row.row.original.is_pending &&
        //     !row.row.original.is_decline) ||
        //   row.row.original.job_description == undefined ||
        //   row.row.original.job_description == null  ? (
        //     <>
        //       <span style={{ color: "green" }}>RM Approved</span>
        //     </>
        //   ) : null} */}

        //         {/* //-----form not filled */}

        //         {!row.row.original.create_employee ? (
        //           //&&
        //           //  ( row.row.original.is_declaration_form != null &&
        //           //   !row.row.original.is_declaration_form) ||
        //           // (row.row.original.is_basic_info != null &&
        //           //   !row.row.original.is_basic_info) ||
        //           // !row.row.original.is_esi_form ||
        //           // (row.row.original.is_id_verification != null &&
        //           //   row.row.original.is_id_verification != null &&
        //           //   !row.row.original.is_id_verification) ||
        //           // (row.row.original.is_previous_employee != null &&
        //           //   !row.row.original.is_previous_employee) ||
        //           // (row.row.original.is_education_detail != null &&
        //           //   !row.row.original.is_education_detail) ||
        //           // (row.row.original.is_bank_details != null &&
        //           //   !row.row.original.is_bank_details) ||
        //           // (row.row.original.is_job_description != null &&
        //           //   !row.row.original.is_job_description) ||
        //           // (row.row.original.is_address_details != null &&
        //           //   !row.row.original.is_address_details)

        //           <>
        //             <span style={{ color: "green" }}>Kyc Pending</span>
        //           </>
        //         ) : null}
        //       </>
        //     );
        //   },
        // },

        {
          Header: "Zone",
          accessor: "",
          Cell: (row) => {
            const [hoveredIndex, setHoveredIndex] = useState(null); // Keep track of which zone is being hovered over
        
            return (
              <>
                {row.row.original.user_id != null &&
                row.row.original.user_id.zone_id != null &&
                row.row.original.user_id.zone_id != undefined ? (
                  <>
                    {row.row.original.user_id.zone_id.length > 0 ? (
                      <div className="UserName">
                        <span className="PTAGs">
                          {row.row.original.user_id.zone_id.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                {item.zone_name.length > 10 ? (
                                  <p
                                    className="PTAGs"
                                    onMouseEnter={() => setHoveredIndex(index)} // Set index on hover
                                    onMouseLeave={() => setHoveredIndex(null)} // Remove hover index when not hovering
                                    style={{ position: 'relative' }} // Ensure relative position for tooltip
                                  >
                                    {item.zone_name.slice(0, 8)}...
                                    {hoveredIndex === index && (
                                      <div className="custom-tooltip">
                                        {item.zone_name}
                                      </div>
                                    )}
                                  </p>
                                ) : (
                                  <p
                                    className="PTAGs"
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    style={{ position: 'relative' }}
                                  >
                                    {item.zone_name}
                                    {hoveredIndex === index && (
                                      <div className="custom-tooltip">
                                        {item.zone_name}
                                      </div>
                                    )}
                                  </p>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </span>
                      </div>
                    ) : (
                      <div className="UserName PTAGs">
                        <span>---</span>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="UserName PTAGs">
                    <span>{"----"}</span>
                  </div>
                )}
              </>
            );
          },
        },        



        {
          Header: "Onboarding Status",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {/* //----For Payroll Pending */}
                {!row.row.original.payroll_approved &&
                row.row.original.is_pending &&
                row.row.original.create_employee ? (
                  <>
                    <span style={{ color: "red" }}> Awaiting for payroll</span>
                  </>
                ) : null}

                {/* -----RM---pending */}
                {(row.row.original.payroll_approved &&
                  !row.row.original.is_pending &&
                  !row.row.original.is_decline &&
                  row.row.original.job_description == null) ||
                (row.row.original.job_description == undefined &&
                  row.row.original.create_employee) ? (
                  <>
                    <span style={{ color: "red" }}>
                      Awaiting for RM approval
                    </span>
                  </>
                ) : null}

                {!row.row.original.is_pending &&
                !row.row.original.is_decline &&
                row.row.original.job_description != undefined &&
                row.row.original.job_description.letter_id != undefined &&
                row.row.original.job_description.letter_id.media_url ? (
                  <>
                    <span style={{ color: "green" }}>KYC Completed</span>
                  </>
                ) : (
                  <span>
                    {/* {"---"} */}

                    
                    {/* row.row.original.payroll_approved &&
                  !row.row.original.is_pending &&
                  !row.row.original.is_decline ? (
                  <>
                    {/* -------RM---Approve--------------- */}

                    {/* <span style={{ color: "red" }}>RM Approved</span>
                  </>
                ) : null} */}
                  </span>
                )}

                {/* -------Payroll---Approve--------------- */}

                {row.row.original.payroll_approved &&
                row.row.original.is_pending ? (
                  <>
                    <span style={{ color: "red" }}>
                      Awaiting for RM approval 
                    </span>
                  </>
                ) : null}

                {!row.row.original.create_employee ? (
                  <>
                    <span style={{ color: "red" }}>Kyc Pending</span>
                  </>
                ) : null}
              </>
            );
          },
        },

        {
          Header: "Status",
          accessor: "",
          Cell: (row) => {
            const [hovered, setHovered] = useState(null); // Hover state for tooltips
        
            return (
              <>
                {/* Decline Status */}
                {row.row.original.is_decline ? (
                  <div className="StatusList">
                    <div className="DeclineStatus">
                      <span>x</span>
                    </div>
                    <span>Decline</span>
                  </div>
                ) : (
                  <>
                    {/* Approved Status */}
                    {!row.row.original.is_pending &&
                    !row.row.original.is_decline &&
                    row.row.original.job_description?.letter_id?.media_url ? (
                      <div className="StatusList">
                        <img src={correctIcons} alt="Approved" />
                        <span>Approved</span>
        
                        {/* Offer Letter Download */}
                        <span
                          className="AllformExcel"
                          style={{ position: "relative" }}
                          onMouseEnter={() => setHovered("offer-letter")}
                          onMouseLeave={() => setHovered(null)}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              row.row.original.job_description.letter_id.media_url,
                              "_blank"
                            );
                          }}
                        >
                          <img src={downloadoffer} alt="Download Offer Letter" />
                          {hovered === "offer-letter" && (
                            <div className="custom-tooltip">Offer Letter</div>
                          )}
                        </span>
        
                        {/* All Form PDF Download */}
                        {row.row.original?.user_id?.id && (
                          <span
                            className="AllformExcel"
                            style={{ position: "relative" }}
                            onMouseEnter={() => setHovered("all-pdf")}
                            onMouseLeave={() => setHovered(null)}
                            onClick={(e) => {
                              e.stopPropagation();
                              const payload = { id: row.row.original.user_id.id, count: 1 };
                              dispatch(sethtmlformatpdfdownoadActions(payload));
                            }}
                          >
                            <img src={allformPdf} alt="All Form PDF" />
                            {hovered === "all-pdf" && (
                              <div className="custom-tooltip">All form PDF</div>
                            )}
                          </span>
                        )}
        
                        {/* Excel Export */}
                        {row.row.original?.user_id?.id && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                            }}
                            onMouseEnter={() => setHovered("excel-export")}
                            onMouseLeave={() => setHovered(null)}
                            onClick={(e) => {
                              e.stopPropagation();
                              setidforuploaddata({
                                ...getidforupload,
                                user_id: row.row.original.user_id.id,
                                client_id: "",
                              });
                              setExcelSheetFORKYCPopup(true);
                            }}
                          >
                            <span className="AllformExcel">
                              <img src={excelSheetImage} alt="Excel Export" />
                              {hovered === "excel-export" && (
                                <div className="custom-tooltip">Excel Export</div>
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        {/* Pending Status */}
                        {row.row.original.is_pending ? (
                          <div className="StatusList">
                            <img src={Pendingimg} alt="Pending" />
                            <span>Pending</span>

                            {row.row.original.payroll_approved &&
                                            row.row.original.is_pending ?
                            <>
                                           

                            
                                            {/* Excel Export */}
                                            {row.row.original?.user_id?.id && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={() => setHovered("excel-export")}
                                                onMouseLeave={() => setHovered(null)}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setidforuploaddata({
                                                    ...getidforupload,
                                                    user_id: row.row.original.user_id.id,
                                                    client_id: "",
                                                  });
                                                  setExcelSheetFORKYCPopup(true);
                                                }}
                                              >
                                                <span className="AllformExcel">
                                                  <img src={excelSheetImage} alt="Excel Export" />
                                                  {hovered === "excel-export" && (
                                                    <div className="custom-tooltip" style={{left:"0"}}>Excel Export</div>
                                                   )} 
                                                </span>
                                              </div>
                                            )}
                                            </>
                                            :""}
                          </div>
                        ) : (
                          <>
                            {/* Completed Status */}
                            {!row.row.original.is_pending &&
                            !row.row.original.is_decline ? (
                              <div className="StatusList">
                                <span>---</span>
                              </div>
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            );
          },
        },
        
                // {
        //   Header: "Download File",
        //   accessor: "",
        //   Cell: (row) => {
        //     return (
        //       <>
        //         <div className="Download-Files">
        //         <i class="fa-solid fa-download"></i>
        //         </div>
        //       </>
        //     );
        //   },
        // },
        // ].filter(Boolean);
      ].filter(Boolean),
    [sno]
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  useEffect(() => {
    if (state.SideBarFiles.SideBarFile == "Overview") {
      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));
    } else if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
      dispatch(setTheOnboardFromDateLIST(range[0]));
      dispatch(setOnboardTODtaeDASH(range[1]));
    } else if (state.SideBarFiles.SideBarFile == "Approve Request") {
      dispatch(setTheEmployeeLISTfromdate(range[0]));
      dispatch(setEmployeeLstTodate(range[1]));
    }
  }, [range]);
  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const cleaningrange = () => {};

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  // console.log(state.ClientBranchIDs.SUBROLE, "SUBROLE");
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // dispatch(SetDashboards(1))

    setdtPageindex(1);
    SetRenderCounts(Counts);
    console.log(Counts, values, sel, "Logs", values == "Completed", selectVal);
    setDisplay(SelectedValues);
    setCounting(2);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    // dispatch(SetDashboards(1));

    if (values == "All") {
      ///All
      // SetRenderCounts(1);
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))




      dispatch(setDropDownRenders(""));
    //   if(range.length > 0){ 

    //   const payloads = {
    //     search: "",
    //     page_size: 20,
    //     page: 1,
    //     // ids: state.ClientBranchIDs.SingelEmployeelistes,
    //     client: Client == undefined ? "" : Client,
    //     is_pending: "",
    //     is_decline: "",
    //     approved: "",

    //     // RenderStatus: RenderStatus,
    //     // payroll_approved: EMpROleSelected,

    //     from_date: range[0],
    //     range: true,

    //     to_date: range[1],
    //   };
    //   dispatch(getEmployeeListPersonsListed(payloads));
    // }
    } else if (values == "ALL") {
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))



      dispatch(setDropDownRenders(""));
      if(range.length > 0){ 

      // const payloads = {
      //   search: "",
      //   page_size: 10,
      //   page: 1,
      //   // ids: state.ClientBranchIDs.SingelEmployeelistes,
      //   client: Client == undefined ? "" : Client,
      //   // is_pending: "",
      //   // is_decline: "",
      //   // approved: "",

      //   // RenderStatus: RenderStatus,
      //   // payroll_approved: EMpROleSelected,

      //   from_date: range[0],
      //   range: true,

      //   to_date: range[1],
      // };
      // dispatch(getEmployeeListPersonsListed(payloads));
    }
    } else if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: false,
        is_decline: false,
        approved: "",
      });

      const StatusFilter ={        is_pending: false,
        is_decline: false,
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))



      dispatch(setDropDownRenders("Completed"));
      if(range.length > 0){ 

      // const payloads = {
      //   search: "",
      //   page_size: dtpagesize,
      //   page: 1,
      //   client: Client == undefined ? "" : Client,

      //   is_pending: false,
      //   is_decline: false,
      //   approved: "",
      //   from_date: range[0],
      //   range: true,

      //   to_date: range[1],
      // };
      // dispatch(getEmployeeListPersonsListed(payloads));
    }
    } else if (values == "Pending") {
      dispatch(setDropDownRenders("Pending"));

      ///Pending
      // SetSelectval({
      //   ...selectVal,
      //   is_pending: true,
      //   is_decline: "",
      //   approved: "",
      // });

      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: false,
        approved: "",
      });


      const StatusFilter ={        is_pending: true,
        is_decline: "",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))



   
    } else if (values == "Decline") {
      dispatch(setDropDownRenders("Decline"));

      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });

      // const StatusFilter ={        is_pending: "",
      //   is_decline:true,
      //   approved:""}
       
      // dispatch(setTheStatusFilter(StatusFilter))


      if(range.length > 0){ 



      // const payloads = {
      //   search: "",
      //   page_size: dtpagesize,
      //   page: 1,
      //   client: Client,
      //   range: true,

      //   is_pending: "",
      //   is_decline: true,
      //   approved: "",
      //   from_date: range[0],

      //   to_date: range[1],
      // };
      // dispatch(getEmployeeListPersonsListed(payloads));
    }
    } else if (values == "Approved") {
      dispatch(setDropDownRenders("Approved"));

      //Approve
      SetSelectval({
        ...selectVal,
        is_decline: "",
        is_pending: "",
        approved: true,
      });


      const StatusFilter ={        is_pending: "",
        is_decline:"",
        approved:true}
       
      dispatch(setTheStatusFilter(StatusFilter))


      if(range.length > 0){ 

      // const payloads = {
      //   search: "",
      //   page_size: dtpagesize,
      //   page: 1,
      //   client: Client,
      //   range: true,

      //   is_pending: "",
      //   is_decline: "",
      //   approved: true,
      //   from_date: range[0],

      //   to_date: range[1],
      // };
      // dispatch(getEmployeeListPersonsListed(payloads));
    }
    }
  };



  const ClearState = (Counts) => {
    //  dispatch(SetDashboards(2))
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
      dispatch(setDropDownRenders(""));
      const StatusFilter ={        is_pending: "",
        is_decline:"",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))


      setCounting(1);
      setdtPageindex(1);
      if(range.length > 0){ 

      // const payloads = {
      //   search: "",
      //   page_size: 20,
      //   page: currentPage,
      //   // ids: state.ClientBranchIDs.SingelEmployeelistes,
      //   client: Client == undefined ? "" : Client,

      //   // RenderStatus: RenderStatus,
      //   // payroll_approved: EMpROleSelected,
      //   range: true,

      //   from_date: range[0],
      //   is_pending: "",
      //   is_decline: "",
      //   approved: "",
      //   to_date: range[1],
      //   state: datas.state,
      //   region: datas.region,
      //   zone: datas.zone,
      // };
      // dispatch(getEmployeeListPersonsListed(payloads));
    }
    }
  };
  // console.log(dtpageindex, "47832sdnh", state.NumberCounts.namerednder);

  const HandleClientBranches = (selectedVal) => {
    //  console.log(selectedVal, "selectedvalue", counts);
    // setdtPageindex(1);

    if (selectedVal != null) {
      dispatch(SetTheDashboardClientList(selectedVal));

      dispatch(getSingleEmployeeActions(selectedVal.value)); /// branch=---list

      // console.log(selectedVal.value, "selectedVal");
      //  console.log("in Search");
      setClients(selectedVal.value);
      // SetSelectValue(selectedVal);
      setClientName(selectedVal.label);
       if(state.SideBarFiles.SideBarFile == "Onboard Overview"){
        dispatch(SetTheDashboardonBoardOverViewClientList(selectedVal))
       }
    } else if (selectedVal == null) {
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      dispatch(getSingleEmployeeActions("")); /// branch=---list


       if(state.SideBarFiles.SideBarFile == "Onboard Overview"){
        dispatch(SetTheDashboardonBoardOverViewClientList({ value: "", label: "ALL" }))

       }
    }
  };


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};
  // console.log(state.NumberCounts.namerednder , "nameRenderws" , PayrollFilters  , EMpROleSelected);
  
  // console.log(state.EmployeeVerificationsNeed.employeelistFROMDATE, "2370420730Inquriy");
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Employee List </h3>
            <br/>
            {/* <ul class="breadcrumb">
              {state.ClientBranchIDs.DashboardIDs != 1 ? (
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    // to={"/"}
                    to={
                      state.SideBarFiles.SideBarFile == "Overview"
                        ? "/"
                        : "/onboardDashboard"
                    }
                    onClick={(e) => {
                      dispatch(
                        getSideBarfilesActions(state.SideBarFiles.SideBarFile)
                      );
                    }}
                  >

                    {state.SideBarFiles.SideBarFile == "Overview"
                      ? "Overview"
                      : "Onboard OverView"}
                  </NavLink>
                </li>
              ) : null}

              <li class="breadcrumb-item active"> Employee List </li>
            </ul> */}
          </div>
        </div>
        {/* {state.ClientBranchIDs.DashboardIDs != 1 ? ( */}
          <div
            className="row Filters ButtonPrevious"
            style={{
              padding: "15px 28px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
                 
              marginLeft: "0px",
              marginRight: "0px",
              top: "-26px",
            }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate(
                    state.SideBarFiles.SideBarFile == "Overview"
                      ? "/"
                      : "/onboardDashboard"
                  );
                }}
              >
                {/* <i class="fa-solid fa-chevron-left"></i> */}
                {/* <span className="PreviousPage"> */}
                  <img  className="PreviousPages" src={BackImage}/>
                  {/* </span> */}
                <span></span>
              </button>
            </div>
          </div>
        {/* ) : null} */}

        <div
          className="row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
          }}
        > 
          {/* <div className="col-6"></div> */}
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndfex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {

                setMuliselect(e);

              }}
              onChange={(e) => {
                handleSelectChange(e);



              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "ALL" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
         isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
           isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   dispatch(SetTheDashboardClientList(e));
              // }}
              onChange={(e) => {
                setdtPageindex(1);
                if (dtpageindex == 1) {
                  HandleClientBranches(e);
                  if (e != null) {
                    setBranchName(e.label);
                  }
                }
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
           isClearable={
            state.SideBarFiles.SideBarFile == "Onboard Overview" ? 
  state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList
    ? Array.isArray(state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList)
      ? state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList.label === "ALL" || state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList.label === "All"
      ? false
      : true
    : true

    :
    state.DashboardCall.DashboardCLientList
    ? Array.isArray(state.DashboardCall.DashboardCLientList)
      ? state.DashboardCall.DashboardCLientList.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.DashboardCall.DashboardCLientList.label === "ALL" || state.DashboardCall.DashboardCLientList.label === "All"
      ? false
      : true
    : true
}              // value={state.DashboardCall.DashboardCLientList}
              value={state.SideBarFiles.SideBarFile == "Onboard Overview" ?
                state.DashboardOnboardOverviewCall.onboardingOverviewdataCLientList
:


state.DashboardCall.DashboardCLientList
              }
            />
          </div>

          <div
            className="col-sm-2 SelectedDate"
 style={{marginTop:"-21px"}}
          >
            <label
              for="validationCustom01 "
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                // defaultValue={
                //   [
                //     new Date(new Date().setDate(today.getDate() - 30)),
                //     new Date(),
                //   ]

                //   // [
                //   //   state.EmployeeVerificationsNeed.FROMDATE,
                //   //   state.EmployeeVerificationsNeed.TODATE,
                //   // ]
                // }

                // defaultValue={[
                //   new Date(state.EmployeeVerificationsNeed.FROMDATE),
                //   new Date(state.EmployeeVerificationsNeed.TODATE),
                // ]}
                defaultValue={
                  state.SideBarFiles.SideBarFile == "Overview"
                    ? [
                        new Date(state.EmployeeVerificationsNeed.FROMDATE),
                        new Date(state.EmployeeVerificationsNeed.TODATE),
                      ]
                    : state.SideBarFiles.SideBarFile == "Onboard Overview"
                    ? [
                        new Date(
                          state.EmployeeVerificationsNeed.ONboardFROMDATE
                        ),
                        new Date(state.EmployeeVerificationsNeed.ONboardTODATE),
                      ]
                    : // : [new Date(), new Date()]
                      //  : [state.EmployeeVerificationsNeed.employeelistFROMDATE, state.EmployeeVerificationsNeed.employeelistTODATE]

                      state.EmployeeVerificationsNeed.employeelistFROMDATE != ""?    [
                        new Date(
                          state.EmployeeVerificationsNeed.employeelistFROMDATE
                        ),
                        new Date(
                          state.EmployeeVerificationsNeed.employeelistTODATE
                        ),
                      ]
                      :
                       []
                }
                components={{
                  // Hide the clear button
                  ClearButton: () => null,
                }}
                                                                  ref={dateRangeRef}

          onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                // onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }

                  // if (e != null && e.length === 2) {
                  //   const [startDate, endDate] = e;
                  //   const diffDays = differenceInDays(endDate, startDate);
                  //   if (diffDays === 30) {
                  //     // Since we are using inclusive range, difference should be 30 for 31 days
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else if (diffDays < 30) {
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else {
                  //     toast.error("Please select a range of exactly 31 days.", {
                  //       position: toast.POSITION.TOP_RIGHT,
                  //     });
                  //   }
                  // }



                }}
              />
            </div>
          </div>
        </div>

        {/* <div className="Branch-Details">
          <div className="innerListBranchDATAS">
            <div className="ICONS">
              <div>
                <img src={clientimg} />
              </div>
              <span>{barnchName}</span>
            </div>
            <div className="ICONS">
              <div>
                <img src={Regionicons} />
              </div>
              <span>{Zone}</span>
            </div>

            
            <div className="ICONS">
              <div>
                <img src={empployeeIcons} />
              </div>
              <span>{EmpInquiry} Employees</span>
            </div>
          </div>
        </div> */}
        {/* <button onClick={(e)=>{
          pageindex(1)
        }}>Click</button> */}

        {/* {Data != undefined && Data != null && Data.length > 0 ? ( */}
        <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          {/* {SubRoleList == 0 ? (
            <div
              // style={{
              //   display: "flex",
              //   justifyContent: "flex-end",
              //   position: "relative",
              //   top: "70px",
              //   zIndex: "1",
              //   justifyContent: "space-around",
              //   alignItems: "center",

              // }}
              className="EmployeeListSearch row"
            >
              <div></div>
              <div
                class="col-sm-2 field-div"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  position: "relative",
                  left: "221px",
                }}
              >
                <label
                  for="validationCustom02"
                  class="form-label FilterLabel"
                  // style={{ fontSize: "15px" }}
                >
                  PayRoll list
                </label>

                <Select
                  className="Selects"
                  styles={{ position: "relative", top: "60px" }}
                  onChange={(e) => {

                    HandleEMprole(e);
                  }}
                  value={EMpROleSelected}
                  options={SubRolePayROllOp}
                  placeholder="search"
                />
              </div>
            </div>
          ) : null} */}
          <ReactTable
            data={
              // Counting == 1 &&
              // state.EmployeeListPresons.Inquriy != undefined &&
              // state.EmployeeListPresons.Inquriy != null
              //  ?

              state.EmployeeListPresons.Inquriy
              // : state.EmployeeListfilterPresons.InquriyFilter
            }
            //data={
            //Counting == 1 ?
            //  Data
            // : FilterHold
            // }
            columns={columns}
            totalItems={
              // Counting == 1
              // ?

              state.EmployeeListPresons.Total_Count
              // : state.EmployeeListfilterPresons.Total_Count
            }
            currentPage={currentPage}
            // onPageChange={handlePageChange}
            onChange={tochange}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            //  dtpageindex={currentPage}
            pageindex={pageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}

            datacount={
              // Counting == 1
              // ?

              state.EmployeeListPresons.Total_Count
              // : state.EmployeeListfilterPresons.Total_Count
            }
            // onPageChange={handlePageChange}
            // onFirstPage={handleFirstPage}
            // OnhandleLastpgae={HandleLastPage}
            MakeCreate={true}
            ViewParts={(e) => {
              handleEmployeeDetails(e);
            }}
            // values={Counting == 1 || Counting == 2 ? objectArray :
            //
            // state.NumberCounts.namerednder == "Decline" ||
            // state.NumberCounts.namerednder == "completed"
            // ?
            // objectArray: selectDisplay
            //
            // }
            // values={Counting == 1 ? objectArray : selectDisplay}

            values={state.NumberCounts.Options}
            options={options}
            Filter={true}
            // ApproveRequestFilter={true}
            count={count}
            ClearState={ClearState}
            // placeHold={place}
            Rmoptions={Rmoptions}
            Rmfilter={Rmfilter}
            Rmfilter03={Rmfilter03}
            // RMStatusFilter={state.ClientBranchIDs.SUBROLE != null && state.ClientBranchIDs.SUBROLE != undefined &&state.ClientBranchIDs.SUBROLE ==  1 ? true : false}
            RMStatusFilter={state.ClientBranchIDs.DashboardIDs == 4 ? true : false}
            PayrollFilter={state.ClientBranchIDs.DashboardIDs == 3 ? true : false}
            AdminFilters={state.ClientBranchIDs.DashboardIDs == 4 ||state.ClientBranchIDs.DashboardIDs == 3 ? true : false}
            // PayrollFilter={state.ClientBranchIDs.SUBROLE != null && state.ClientBranchIDs.SUBROLE  != undefined && state.ClientBranchIDs.SUBROLE == 0 ? true : false}
            HandlePayrollFilter={HandleEMprole}
            EMPayrollSelected={EMpROleSelected}
            SubRolePayROllOp={SubRolePayROllOp}
            setsno={setsno}
            sno={sno}
            id={"spe"}
          />
        </div>
        {/* ) : <p>no Data</p>} */}
      </div>
      <>
        {ExcelSheeTFORKYCPopup ? (
          <ExcelFormatDwonload
            show={ExcelSheeTFORKYCPopup}
            setShow={setExcelSheetFORKYCPopup}
            EditID={getidforupload}
          />
        ) : null}
      </>
    </>
  );
};

export default EmployeeList;
